/** @format */

import {isInTheRange} from 'helpers/dateHelpers';

import {getPlanForDate} from 'features/mediaplan-progress/helpers/getPlanForDate';
import {reducePlanToPeriod} from 'features/mediaplan-progress/helpers/reducePlanToPeriod';

import {CHARTS_PREDICATES} from '../constants/predicates';
import getChartIdByKpiName from '../helpers/getChartIdByKpiName';
import {MediaplanFromQuery} from '../models/api';
import {ChartIds} from '../models/chartIds';

export interface GetPlanPointOptions {
  currentDate: string;
  chartId: ChartIds;
  mediaplans: ReadonlyArray<MediaplanFromQuery>;
}

const getPlanPoint = ({
  currentDate,
  chartId,
  mediaplans,
}: GetPlanPointOptions): number | undefined => {
  const dateObj = new Date(currentDate);

  const myPeriod = mediaplans.find(plan =>
    isInTheRange({
      startOn: new Date(plan.startOn),
      endOn: plan.endOn ? new Date(plan.endOn) : undefined,
      currentDate: dateObj,
    }),
  );

  if (!myPeriod) {
    // нет планов на этот день
    return;
  }

  // Получаем числовое значение плана из api

  const {budget, kpis, startOn, endOn, repeat} = myPeriod;
  let value: number | string | undefined;

  if (chartId === 'budget') {
    value = budget;
  } else {
    value = (kpis ?? []).find(kpi => getChartIdByKpiName(kpi.name) === chartId)?.value;
  }

  let parsedValue: number;

  if (value === undefined || typeof value === 'string') {
    parsedValue = parseInt(value || '');
  } else {
    parsedValue = value;
  }

  if (isNaN(parsedValue)) {
    return;
  }

  // Реализуем логику из этой задачи https://adsensor-ru.atlassian.net/browse/AS-6093

  const hasSecondary = Boolean(CHARTS_PREDICATES[chartId]?.secondaryPredicate);
  const kind = hasSecondary ? 'additive' : 'ratio';

  const period = reducePlanToPeriod({
    plan: {startOn, endOn: endOn ?? null, repeat: repeat ?? null},
    currentDate,
  });

  return getPlanForDate({kind, planForPeriod: parsedValue, period});
};

export default getPlanPoint;
